import { render, staticRenderFns } from "./thyaktarim.vue?vue&type=template&id=44637d25&"
import script from "./thyaktarim.vue?vue&type=script&lang=js&"
export * from "./thyaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports